import React, { useEffect } from "react";
import "./Profile.css";
import Account from "../Components/Profile/Profile";
import CardMembers from "../Components/ProfileCardsMembers/ProfileCardsMembers";
import Breadcrumb from "../Components/Breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

function Members() {
    const { t, i18n, ready } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkForcePayment = async () => {
            const response = await axios.get(config.url + "users/id/me", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            if (response.data?.user?.forcePayment) {
                navigate("/membership-credits", { replace: true });
            }
        };

        checkForcePayment().catch((error) => {
            console.log(error);
        });
    }, []);

    return (
        <section className="profile-section">
            <Breadcrumb pageTitle={t("Members")} text = {t("Step out of your comfort zone and discover the magic of meeting new people")} />

            <div className="container">
                <div className="row">
                    <div className="col-md-3 mb-3 left-side">
                        <Account />
                    </div>
                    <div className="col-md-9 mb-3 left-side">
                        <CardMembers />
                    </div>
                </div>
                <div className="left-side"></div>
            </div>
        </section>
    );
}

export default Members;
